// const base_url = 'https://us-central1-df-kirin.cloudfunctions.net';
// const report_v1 = base_url + '/rp/v1';
// const report_v2 = base_url + '/rpV2/v2';
// export { report_v1, report_v2 };

const base_url = "https://report-wfoxr6wg7q-uc.a.run.app";
const report_v1 = base_url + "/v2";
const report_v2 = base_url + "/v2";
export { report_v1, report_v2 };
